import ajax from '../util/ajax';

/**
 * 国内学术研究相关情况
 */
export function learning() {
    return ajax({
        url: '/scimallH5/Dxsv2xsdt/learning'
    });
}

/**
 * 国内学术研究相关情况（折线图）
 */
export function brokenLine(params) {
    return ajax({
        url: '/scimallH5/Dxsv2xsdt/brokenLine',
        params
    });
}

/**
 * 国内科研活动相关情况
 */
export function scientificActivity() {
    return ajax({
        url: '/scimallH5/Dxsv2xsdt/scientificActivity'
    });
}

/**
 * 左下角饼状图
 */
export function learningChart() {
    return ajax({
        url: '/scimallH5/Dxsv2xsdt/chart'
    });
}

/**
 * 世界地图
 */
export function map() {
    return ajax({
        url: '/scimallH5/Dxsv2xsdt/map'
    });
}

/**
 * 中外学术研究比较 折线图
 */
export function academicResearch() {
    return ajax({
        url: '/scimallH5/Dxsv2xsdt/academicResearch'
    });
}

/**
 * 中外学术研究比较 对应饼状图
 */
export function academicResearchChart(params) {
    return ajax({
        url: '/scimallH5/Dxsv2xsdt/academicResearchChart',
        params
    });
}


/**
 * 国内期刊发展情况
 */
export function getPeriodical() {
    return ajax({
        url: '/scimallH5/Dxsxsdt/getPeriodical'
    });
}


/***   国内学术研究相关情况 - 二级  ***/


/**
 * 各领域论文活跃指数
 */
export function paperActive() {
    return ajax({
        url: '/scimallH5/Dxsv2gnxs/paperActive'
    });
}


/**
 * 论文引文影响力
 */
export function gnxsPaperInfluence(country) {
    return ajax({
        url: '/scimallH5/Dxsv2gnxs/paperInfluence',
        params: {
            country: country
        }
    });
}

/**
 * 中国高被引论文被各国引用情况
 */
export function paperQuoteByForeign() {
    return ajax({
        url: '/scimallH5/Dxsv2gnxs/paperQuoteByForeign'
    });
}

/**
 * 国内高校论文发文量排名
 */
export function schoolPapers() {
    return ajax({
        url: '/scimallH5/Dxsxsdt/schoolPapers'
    });
}
/**
 * 各省市论文数量占比
 */
export function paperPublishScale(params) {
    return ajax({
        url: '/scimallH5/Dxsv2gnxs/paperPublishScale',
        params
    });
}

/**
 * 各省市被引量占比
 */

export function paperQuotesScale(params) {
    return ajax({
        url: '/scimallH5/Dxsv2gnxs/paperQuotesScale',
        params
    });
}
/**
 * 各省市发文量
 */
export function paperPublish() {
    return ajax({
        url: '/scimallH5/Dxsv2gnxs/paperPublish'
    });
}


/***   国内科研活动相关情况 - 二级  ***/


/**
 *  上部分 折线图
 */
export function kyBrokenLine() {
    return ajax({
        url: '/scimallH5/Dxsv2kyhd/brokenLine'
    });
}
/**
 *  地图
 */
export function kyMap(params) {
    return ajax({
        url: '/scimallH5/Dxsv2kyhd/map',
        params
    });
}
/**
 *  关联右侧饼状图
 */
export function kylinkAge(params) {
    return ajax({
        url: '/scimallH5/Dxsv2kyhd/linkAge',
        params
    });
}


/***  中外学术研究比较 - 二级  ***/


/**
 *  各国发文量
 */
export function worldPublishCount() {
    return ajax({
        url: '/scimallH5/Dxsv2world/worldPublishCount'
    });
}

/**
 *  论文高被引数量
 */
export function topPaperCount(country) {
    return ajax({
        url: '/scimallH5/Dxsv2world/topPaperCount',
        params: {
            country: country
        }
    });
}

/**
 * 论文引文影响力
 */
export function paperInfluence(country) {
    return ajax({
        url: '/scimallH5/Dxsv2world/paperInfluence',
        params: {
            country: country
        }
    });
}

/**
 *  论文数量占全球份额
 */
export function paperCountScale(country) {
    return ajax({
        url: '/scimallH5/Dxsv2world/paperCountScale',
        params: {
            country: country
        }
    });
}

/**
 * 论文引用占全球份额
 */
export function paperQuoteScale(country) {
    return ajax({
        url: '/scimallH5/Dxsv2world/paperQuoteScale',
        params: {
            country: country
        }
    });
}

/**
 *   各领域引文影响力
 */
export function fieldPaperInfluence(country) {
    return ajax({
        url: '/scimallH5/Dxsv2world/fieldPaperInfluence',
        params: {
            country: country
        }
    });
}

/**
 *  各领域活跃指数
 */
export function fieldPaperActive(country) {
    return ajax({
        url: '/scimallH5/Dxsv2world/fieldPaperActive',
        params: {
            country: country
        }
    });
}


/***  国内期刊发展 - 二级  ***/


/**
 *  Elsevier收录的中国期刊里外国作者占比
 */
export function getAuthorProportion() {
    return ajax({
        url: '/scimallH5/Dxsv2qkfz/getAuthorProportion'
    });
}


/**
 *  Elsevier收录的各国期刊发文量比较
 */
export function getPostProportion() {
    return ajax({
        url: '/scimallH5/Dxsv2qkfz/getPostProportion'
    });
}


/**
 *  Elsevier收录的各国期刊影响因子比较 Elsevier收录的中国期刊被各国引用量占比
 */
export function getBrokenLine(brokenParam) {
    return ajax({
        url: '/scimallH5/Dxsv2qkfz/getBrokenLine',
        params:{
            first_name:brokenParam.first_name,
            second_name:brokenParam.second_name
        }
    });
}


/**
 *  1 : SCI收录的我国科技人员在国内外期刊上发表论文的比重
 *  2 : EI收录的我国科技人员在国内外期刊上发表论文的比重
 */
export function getPaperProportion(type = 1) {
    return ajax({
        url: '/scimallH5/Dxsv2qkfz/getPaperProportion',
        params: {
            type: type
        }
    });
}


/**
 *  中文科技期刊刊登的科技论文篇数按机构类型分类
 */
export function getOrganizationType() {
    return ajax({
        url: '/scimallH5/Dxsv2qkfz/getOrganizationType'
    });
}

/**
 *  学术热词
 */
export function hotWords() {
    return ajax({
        url: '/scimallH5/Dxsv2xsdt/hotWords'
    });
}

/**
 *  学术研究进展资讯
 */
export function getLearningArticle() {
    return ajax({
        url: '/scimallH5/Dxsxsdt/getLearningArticle'
    });
}



